export default __webpack_public_path__ + "054d1988d1ce5136f86c4fa715d1d59a.png";